<app-layout size="100%">
  <app-breadcrumb [breadcrumbItems]="[
  { label: ('breadcrumb.login' | translate), link: '/' },
  { label: ('breadcrumb.resetPassword' | translate) }
]"></app-breadcrumb>
  <div class="change-password-container">
    <div class="form-section">
      <app-title title="changePassword.header" />
      <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">

        <app-input [label]="'changePassword.newPassword' | translate" [formGroup]="passwordForm" name="newPassword"
          type="password" [required]="true" (input)="checkPassword()"></app-input>

        <app-input [label]="'changePassword.confirmPassword' | translate" [formGroup]="passwordForm"
          name="confirmPassword" type="password" [required]="true"></app-input>

        @if (passwordMismatch) {
        <div class="error">
          {{ 'changePassword.passwordMismatch' | translate }}
        </div>
        }

        @if (apiError) {
        <div class="error">
          @if (apiError.translationKey) {
          {{ apiError.translationKey | translate }}
          } @else {
          {{ apiError.rawMessage }}
          }
        </div>
        }

        <div class="button-group">
          @if (button_clicked) {
          <app-spinner></app-spinner>
          } @else {
          <app-button variant="primary">
            <button type="submit" data-testid="password-reset-login-submit"
              [disabled]="!passwordForm.valid || passwordMismatch">
              {{ 'changePassword.changePasswordInput' | translate }}
            </button>
          </app-button>
          }

          <app-button variant="secondary">
            <a routerLink="/" queryParamsHandling="preserve" class="btn btn-secondary">
              {{ 'changePassword.cancel' | translate }}
            </a>
          </app-button>
        </div>
      </form>
    </div>

    <div class="requirements-section">
      <div class="requirements">
        <h4>{{ 'changePassword.requirementsHeader' | translate }}</h4>
        <ul>
          <li [class.valid]="validations.minLength">{{ 'changePassword.requirement1' | translate }}</li>
          <li [class.valid]="validations.uppercase">{{ 'changePassword.requirement2' | translate }}</li>
          <li [class.valid]="validations.number">{{ 'changePassword.requirement3' | translate }}</li>
          <li [class.valid]="validations.specialChar">{{ 'changePassword.requirement4' | translate }}</li>
        </ul>
      </div>
    </div>
  </div>
</app-layout>